module.exports = __webpack_public_path__ + "static/media/PORTADA.30b98814.jpg";